import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./css/normalize.css";
import "./css/components.css";
import "./css/the-fold-44b39e.css";
import "./css/style.css";

import { CONFIG } from "./config";

import * as serviceWorker from "./serviceWorker";

//DETECT DEBUG MODE
if (window.location.hash === "#debug") {
	CONFIG.d_enableDebug = true;
	CONFIG.d_enableDebugUI = true;
	CONFIG.d_enableDebugVar = true;
	CONFIG.d_enableUI = false;
} else {
	CONFIG.d_enableDebug = false;
	CONFIG.d_enableDebugUI = false;
	CONFIG.d_enableDebugVar = false;
	CONFIG.d_enableUI = true;
}

// ReactDOM.render(
// 	<React.StrictMode>
// 		<Entry />
// 	</React.StrictMode>,
// 	document.getElementById("root")
// );

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
